import React, { useEffect } from "react";
import Navbar from "../Components/Navbar/Navbar";
import section from "../Assets/profile-pic-1.jpg";
import ImageSlider from "../Components/Slider/Slider2";
import Footer from "../Components/Footer/Footer";
import { animateScroll as scroll } from "react-scroll";
import Services from "../Components/Services/Services";
import Project from "../Components/Services/Project";
import { Link } from "react-router-dom";
import TopPageButton from "../Components/TopPage/TopePage";
import { Helmet } from "react-helmet-async";
import Typewriter from "../Components/Effect/Typewriter";
import blogImage from "../Assets/blog-bg.png";
import meetingImage from "../Assets/meeting-section.png";

const Home = () => {
  useEffect(() => {
    document.title = "Aneeq Ullah Khan | Home";
    scroll.scrollToTop({ duration: 500 });
  }, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>Aneeq Ullah Khan | Home</title>
        <meta
          name="description"
          content="My name is Aneeq Ullah Khan, and I'm a MERN stack developer, Firebase and PHP developer.I studied at Aptech Pakistan, Jawan Pakistan and am currently pursuing a Bachelor's degree in Computer Science from Iqra University. Throughout my academic and professional career, I've honed my skills in full-stack web development, front-end development, and back-end development, among other areas."
        />
        <meta
          name="keywords"
          content="Aneeq, Aneeq Ullah Khan, Aneeq Ullah Khan Portfolio, Aneeq Khan, Aneeq Portfolio, Aneeq Resume, Aneeq CV, Aneeq Firebase, Aneeq Ullah Khan Fiverr, Aneeq Ullah Khan Linkedin, React, React Js, Aneeq Ullah Khan React Developer, Top Pakistan React Developer, Pakistan Developer, Top Pakistan Frontend Developer, Frontend Developer, Top Pakistani"
        />
      </Helmet>
      <Navbar />
      <div className="bg-section">
        <div className="container">
          <div className="row">
            <div className="col-sm-4 col-md-4 col-lg-3">
              <div className="section-1" data-aos="fade-right">
                <div className="image-wrapper-1" data-aos="zoom-in">
                  <img src={section} alt="Aneeq" style={{ height: "17rem" }} />
                </div>
              </div>
            </div>
            <div className="col-sm-8 col-md-8 col-lg-9">
              <div className="section-1">
                <b className="text-aneeq">ANEEQ ULLAH KHAN</b>
                <p style={{ margin: "0px" }}>
                  <p style={{ fontSize: "20px" }}>
                    MERN Stack Developer | JavaScript Developer | Frontend
                    Developer | <br /> Wordpress Developer | Firebase Developer
                    | Software Engineer
                  </p>
                </p>
                {/* <p
                  style={{ margin: "0px 0px 30px", fontSize: "18px" }}
                  className="try-me"
                >
                  Hello ! Try Me Out
                </p> */}
                <Typewriter /> <br />
              </div>
              <div className="d-flex flex-row mb-3 category">
                <div className="category-tab p-2 bg-dark animation-1">
                  <div className="text-center mt-2">
                    <a
                      href="https://www.linkedin.com/in/aneeq-ullah-khan/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                      >
                        <path
                          fill="#0288D1"
                          d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                        ></path>
                        <path
                          fill="#FFF"
                          d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="category-tab p-2 bg-dark animation-2">
                  <div className="text-center mt-2">
                    <a
                      href="https://github.com/AneeqUllahKhan"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                      >
                        <path d="M17.791,46.836C18.502,46.53,19,45.823,19,45v-5.4c0-0.197,0.016-0.402,0.041-0.61C19.027,38.994,19.014,38.997,19,39 c0,0-3,0-3.6,0c-1.5,0-2.8-0.6-3.4-1.8c-0.7-1.3-1-3.5-2.8-4.7C8.9,32.3,9.1,32,9.7,32c0.6,0.1,1.9,0.9,2.7,2c0.9,1.1,1.8,2,3.4,2 c2.487,0,3.82-0.125,4.622-0.555C21.356,34.056,22.649,33,24,33v-0.025c-5.668-0.182-9.289-2.066-10.975-4.975 c-3.665,0.042-6.856,0.405-8.677,0.707c-0.058-0.327-0.108-0.656-0.151-0.987c1.797-0.296,4.843-0.647,8.345-0.714 c-0.112-0.276-0.209-0.559-0.291-0.849c-3.511-0.178-6.541-0.039-8.187,0.097c-0.02-0.332-0.047-0.663-0.051-0.999 c1.649-0.135,4.597-0.27,8.018-0.111c-0.079-0.5-0.13-1.011-0.13-1.543c0-1.7,0.6-3.5,1.7-5c-0.5-1.7-1.2-5.3,0.2-6.6 c2.7,0,4.6,1.3,5.5,2.1C21,13.4,22.9,13,25,13s4,0.4,5.6,1.1c0.9-0.8,2.8-2.1,5.5-2.1c1.5,1.4,0.7,5,0.2,6.6c1.1,1.5,1.7,3.2,1.6,5 c0,0.484-0.045,0.951-0.11,1.409c3.499-0.172,6.527-0.034,8.204,0.102c-0.002,0.337-0.033,0.666-0.051,0.999 c-1.671-0.138-4.775-0.28-8.359-0.089c-0.089,0.336-0.197,0.663-0.325,0.98c3.546,0.046,6.665,0.389,8.548,0.689 c-0.043,0.332-0.093,0.661-0.151,0.987c-1.912-0.306-5.171-0.664-8.879-0.682C35.112,30.873,31.557,32.75,26,32.969V33 c2.6,0,5,3.9,5,6.6V45c0,0.823,0.498,1.53,1.209,1.836C41.37,43.804,48,35.164,48,25C48,12.318,37.683,2,25,2S2,12.318,2,25 C2,35.164,8.63,43.804,17.791,46.836z"></path>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="category-tab p-2 bg-dark animation-3">
                  <div className="text-center mt-2">
                    <a
                      href="https://www.fiverr.com/aneeqkhan17"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                      >
                        <circle cx="24" cy="24" r="20" fill="#66bb6a"></circle>
                        <path
                          fill="#fff"
                          d="M35.066,22.035v-0.959h-1.821l-0.8-0.014c-0.684,0-1.151,0.45-1.335,0.974v-0.959h-2.039V27.3 h2.039v-1.334v-2.066c0-0.62,0.503-1.123,1.123-1.123h0.795v4.523h2.039v-1.334v-2.066c0-0.62,0.503-1.123,1.123-1.123h1.012v-1.7 l-0.8-0.014C35.718,21.061,35.25,21.512,35.066,22.035z M20.56,21.206l-1.094,3.597l-1.093-3.597h-2.039l2.215,6.223h0.12h1.597 h0.12l2.213-6.223H20.56z M12.23,21.206v-0.415c0-0.364,0.294-0.658,0.658-0.658h1.287v-1.706h-1.767 c-1.223,0-2.216,0.991-2.216,2.216v0.564H9v1.649h1.192v4.572h2.039v-4.572h1.944v4.572h2.039v-4.572v-1.649h-2.039H12.23V21.206z M25.424,21.122h-0.248c-1.67,0-3.024,1.354-3.024,3.024v0.342c0,1.67,1.354,3.024,3.024,3.024h0.552 c1.143,0,2.122-0.706,2.524-1.705l-1.798-0.525c0,0-0.215,0.616-0.965,0.616c-0.847,0-1.295-0.463-1.354-0.989l0,0v-0.003 c-0.004-0.038-0.006-0.077-0.006-0.115h2.3h2.022v-0.643C28.448,22.476,27.094,21.122,25.424,21.122z M24.13,23.59 c0.025-0.559,0.485-1.006,1.051-1.006h0.194c0.565,0,1.026,0.446,1.051,1.006H24.13z"
                        ></path>
                        <circle
                          cx="38.852"
                          cy="26.305"
                          r="1.268"
                          fill="#263238"
                        ></circle>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="category-tab p-2 bg-dark animation-4">
                  <div className="text-center mt-2">
                    <a
                      href="https://www.facebook.com/Aneequllahkhan.18/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                      >
                        <linearGradient
                          id="Ld6sqrtcxMyckEl6xeDdMa_uLWV5A9vXIPu_gr1"
                          x1="9.993"
                          x2="40.615"
                          y1="9.993"
                          y2="40.615"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#2aa4f4"></stop>
                          <stop offset="1" stop-color="#007ad9"></stop>
                        </linearGradient>
                        <path
                          fill="url(#Ld6sqrtcxMyckEl6xeDdMa_uLWV5A9vXIPu_gr1)"
                          d="M24,4C12.954,4,4,12.954,4,24s8.954,20,20,20s20-8.954,20-20S35.046,4,24,4z"
                        ></path>
                        <path
                          fill="#fff"
                          d="M26.707,29.301h5.176l0.813-5.258h-5.989v-2.874c0-2.184,0.714-4.121,2.757-4.121h3.283V12.46 c-0.577-0.078-1.797-0.248-4.102-0.248c-4.814,0-7.636,2.542-7.636,8.334v3.498H16.06v5.258h4.948v14.452 C21.988,43.9,22.981,44,24,44c0.921,0,1.82-0.084,2.707-0.204V29.301z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>

                <div className="category-tab p-2 bg-dark animation-5">
                  <div className="text-center mt-2">
                    <a
                      href="https://www.instagram.com/aneeqprivv_/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                      >
                        <radialGradient
                          id="yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1"
                          cx="19.38"
                          cy="42.035"
                          r="44.899"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#fd5"></stop>
                          <stop offset=".328" stop-color="#ff543f"></stop>
                          <stop offset=".348" stop-color="#fc5245"></stop>
                          <stop offset=".504" stop-color="#e64771"></stop>
                          <stop offset=".643" stop-color="#d53e91"></stop>
                          <stop offset=".761" stop-color="#cc39a4"></stop>
                          <stop offset=".841" stop-color="#c837ab"></stop>
                        </radialGradient>
                        <path
                          fill="url(#yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1)"
                          d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"
                        ></path>
                        <radialGradient
                          id="yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2"
                          cx="11.786"
                          cy="5.54"
                          r="29.813"
                          gradientTransform="matrix(1 0 0 .6663 0 1.849)"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#4168c9"></stop>
                          <stop
                            offset=".999"
                            stop-color="#4168c9"
                            stop-opacity="0"
                          ></stop>
                        </radialGradient>
                        <path
                          fill="url(#yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2)"
                          d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"
                        ></path>
                        <path
                          fill="#fff"
                          d="M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5	s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"
                        ></path>
                        <circle
                          cx="31.5"
                          cy="16.5"
                          r="1.5"
                          fill="#fff"
                        ></circle>
                        <path
                          fill="#fff"
                          d="M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12	C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-5">
          <br />
          <h3 className="animate-charcter">About Me</h3>

          <p className="text-class">
            <q>
              Hello, and welcome to my portfolio profile! My name is Aneeq Ullah
              Khan, and I'm a MERN stack developer, Firebase and PHP developer.I
              studied at Aptech Pakistan, Jawan Pakistan and am currently
              pursuing a Bachelor's degree in Computer Science from Iqra
              University. Throughout my academic and professional career, I've
              honed my skills in full-stack web development, front-end
              development, and back-end development, among other areas.
              Throughout my career, I have developed a strong understanding of
              the front-end development process, and I specialize in building
              modern web applications using the latest technologies and
              frameworks. I'm passionate about building high-quality, scalable,
              and efficient web applications that meet the needs of users and
              clients alike. I'm always on the lookout for new challenges and
              opportunities to learn and grow, and I'm committed to staying
              up-to-date with the latest technologies and best practices in my
              field. If you're interested in working with me or learning more
              about my skills and experience, please don't hesitate to reach
              out!
            </q>
          </p>
        </div>

        {/* <div className="container text-center">
          <p className="section-text1">
            About Me
            <div className="arrowdown"></div> <br /> <br />
          </p>
          <div className="row justify-content-center align-items-center">
            <div className="col-xs-4 col-sm-6 col-sm-6 col-lg-7">
              <div className="shadow-box">
                <div className="mt-2 mb-2">
                  <p className="text-class">
                    <q>
                      Hello, and welcome to my portfolio profile! My name is
                      Aneeq Ullah Khan, and I'm a MERN stack developer, Firebase
                      and PHP developer.I studied at Aptech Pakistan, Jawan
                      Pakistan and am currently pursuing a Bachelor's degree in
                      Computer Science from Iqra University. Throughout my
                      academic and professional career, I've honed my skills in
                      full-stack web development, front-end development, and
                      back-end development, among other areas. Throughout my
                      career, I have developed a strong understanding of the
                      front-end development process, and I specialize in
                      building modern web applications using the latest
                      technologies and frameworks. I'm passionate about building
                      high-quality, scalable, and efficient web applications
                      that meet the needs of users and clients alike. I'm always
                      on the lookout for new challenges and opportunities to
                      learn and grow, and I'm committed to staying up-to-date
                      with the latest technologies and best practices in my
                      field. If you're interested in working with me or learning
                      more about my skills and experience, please don't hesitate
                      to reach out!
                    </q>
                  </p>
                </div>
              </div>
            </div>
          </div>{" "}
          <br /> <br />
        </div> */}
      </div>

      <div className="container">
        <p className="section-text2 text-center" data-aos="fade-up">
          Services
        </p>
        <Services />
        <div className="text-center mt-5 mb-3">
          <Link to="/services">
            <button className="btn-more"> View More Services</button>
          </Link>
        </div>
      </div>

      <div className="container">
        <p className="section-text2 text-center" data-aos="fade-up">
          Projects
        </p>
        <Project />
        <div className="text-center mt-5 mb-3">
          <Link to="/projects">
            <button className="btn-more"> View More Projects</button>
          </Link>
        </div>
      </div>

      <div className="container mt-5 mb-5 bg-dark rounded">
        <div className="row">
          <div className="col-lg-6">
            <br />
            <div className="mt-3 mb-5 text-blog-align" data-aos="zoom-right">
              <h1 className="text-blog">
                The Best <br /> Tech Blogs
              </h1>

              <br />

              <a
                href="https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7119291281628889089"
                target="_blank"
                className="btn-subscribe"
                rel="noreferrer"
              >
                Subscribe On LinkedIn
              </a>
            </div>
            <br />
          </div>
          <div className="col-lg-6">
            <div className="text-end">
              <img src={blogImage} alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-5 mb-5 bg-dark rounded">
        <div className="row">
          <div className="col-lg-6">
            <div className="text-end">
              <img src={meetingImage} alt="" className="img-fluid" />
            </div>
            <br />
          </div>
          <div className="col-lg-6">
            <div
              className="container mt-3 mb-5 text-meeting-align"
              data-aos="zoom-right"
            >
              <h1 className="text-meeting">
                Book Your <br /> Meeting With Me
              </h1>
              <p>
                By clicking on the below "Book Now" button you will be navigated
                towards the meeting page just fill up the form and confirm your
                meeting with me.
              </p>

              <br />

              <Link to="/book-meeting" className="btn-subscribe">
                Book Now
              </Link>
            </div>
            <br />
          </div>
        </div>
      </div>

      <div className="container text-center mb-4">
        <p className="section-text2">My Technologies</p>
        {/* <CompanySlider /> */}
        <ImageSlider />
      </div>

      <Footer />
      <TopPageButton />
    </React.Fragment>
  );
};

export default Home;
